import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { GetDetailRequest } from '../ServerApi/requests/GetDetailRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { IDetailFetcher } from './IDetailFetcher';
import WebHttpClient from '../../httpClient/WebHttpClient';

export class ServerDetailFetcher<TResource, TRequestResult extends IResult> implements IDetailFetcher<TResource> {

  constructor(
    private $q: ng.IQService,
    private requestMethod: string,
    private resultMapper: (result: TRequestResult) => TResource
  ) { }

  public fetchById(id: string): Promise<TResource> {
    return WebHttpClient.sendRequest(new GetDetailRequest<TRequestResult>(this.requestMethod, id))
      .then(ResultHelper.rejectResultOnError(this.$q))
      .then<TResource>(
        (result: TRequestResult) => Promise.resolve(this.resultMapper(result)),
        (result: IResult) => Promise.reject(result.errors && result.errors[0] && result.errors[0].code)
      );
  }

}
